import A from 'utils/metrics/analytic'

enum lectorOrigin {
  NOORIGIN = 'noorigin',
  ARTICLE = 'article',
  WEBINAR_LIVE = 'webinar_live',
  WEBINAR_PAST = 'webinar_past',
  LECTUR_LIST = 'lectur_list',
  LECTUR_PAGE = 'lectur_page',
  LECTOR = 'lectur_personalpage',
}

const A_subLector = (origin: lectorOrigin, id: string) => {
  A.setEvent('lectur_click_subscription', { origin, id })
}

export { A_subLector, lectorOrigin }
